<h2>Historik</h2>
@if (shouldShowHistoryRemark()) {
  <form [formGroup]="notesForm" class="history">
    <div class="form-row no-margin-bottom">
      <mat-form-field appearance="outline" class="mdc-textarea-fix">
        <mat-label>Bemærkning</mat-label>
        <textarea formControlName="remark" rows="4" matInput></textarea>
      </mat-form-field>
    </div>
    @if (remark?.dirty || remark?.touched) {
      <div class="margin--bottom-l align-center">
        <button [disabled]="!notesForm?.valid || !canWrite" (click)="AddRemark()" mat-raised-button color="primary">Tilføj bemærkning</button>
      </div>
    }
  </form>
}
<div class="history">
  @for (historyEntry of filteredHistoryEntries; track historyEntry) {
    <div class="history__item">
      <div
        class="history__icon"
        [class.history__icon--red]="['Delete', 'Error'].indexOf(historyEntry.typeOfChange.toString()) > -1"
        [class.history__icon--green]="historyEntry.typeOfChange === 'Update' || historyEntry.typeOfChange === 'Success'"
        [class.history__icon--black]="historyEntry.typeOfChange === 'Remark' && !historyEntry.isDeleted"
        [class.history__icon--green-light]="historyEntry.typeOfChange === 'Create' || historyEntry.typeOfChange === 'Read'"
        [matTooltip]="isSystem(historyEntry) ? 'Handling udført af system' : 'Handling udført af ' + historyEntry.responsibleUser"
        >
        <span>
          @if (!isSystem(historyEntry)) {
            {{ historyEntry.responsibleUser }}
          } @else {
            <mat-icon svgIcon="system"></mat-icon>
          }
        </span>
        <div class="history__icon-sec">
          @if (historyEntry.typeOfChange === 'Create') {
            <mat-icon svgIcon="add-small"></mat-icon>
          }
          @if (historyEntry.typeOfChange === 'Update') {
            <mat-icon svgIcon="edit"></mat-icon>
          }
          @if (historyEntry.typeOfChange === 'Read') {
            <mat-icon svgIcon="document"></mat-icon>
          }
          @if (historyEntry.typeOfChange === 'Delete') {
            <mat-icon svgIcon="delete"></mat-icon>
          }
          @if (historyEntry.typeOfChange === 'Remark') {
            <mat-icon svgIcon="note"></mat-icon>
          }
          @if (historyEntry.typeOfChange === 'Error') {
            <mat-icon svgIcon="alert-solid"></mat-icon>
          }
          @if (historyEntry.typeOfChange === 'Success') {
            <mat-icon svgIcon="thumb-up"></mat-icon>
          }
          @if (historyEntry.typeOfChange === 'Email') {
            <mat-icon svgIcon="mail"></mat-icon>
          }
        </div>
      </div>
      <div class="history__con">
        <div class="history__info" [class.red]="historyEntry.typeOfChange === 'Error'" [class.bold]="historyEntry.typeOfChange === 'Error'">
          {{ historyEntry.action }} ⋅ {{ getEntryTimestamp(historyEntry.timestamp) }}
        </div>
        <div class="history__details">
          {{ historyEntry.isDeleted ? 'Bemærkning slettet' : historyEntry.details }}
          @if (historyEntry.typeOfChange === 'Email' && historyEntry.attachmentUrl) {
            <span>
              <a
                [href]="historyEntry.attachmentUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="blue"
                [matTooltip]="'Se e-mail i arkivet'"
                >
                <mat-icon svgIcon="mail"></mat-icon>
              </a>
            </span>
          }
        </div>
        @if (historyEntry.typeOfChange === 'Remark' && (historyEntry.responsibleUser == currentUsername || isAdmin)) {
          <div
            class="history__hover"
            >
            @if (!historyEntry.isDeleted) {
              <button
                class="btn-icon blue margin--bottom-s"
                (click)="EditRemark(historyEntry)"
                [matTooltip]="'Rediger element'"
                >
                <mat-icon svgIcon="edit"></mat-icon>
              </button>
            }
            @if (!historyEntry.isDeleted) {
              <button class="btn-icon red" (click)="DeleteRemark(historyEntry)" [matTooltip]="'Slet element'">
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
